<template>
  <div class="specials__body">
    <div class="feedback">
      <transition name="fade" @enter="enterErrorFeedback">
        <FeedbackError v-if="showableErrorFeedback" :message="errorMessage" />
      </transition>
    </div>
    <div v-if="isLoading" class="specials__loading">
      <Loading />
    </div>
    <div v-else>
      <SpecialBoxes :specials="specials" />
      <Pagination
        :current-page="currentPage"
        :total-pages="totalPages"
        @clicked="onClickPageLink"
      />
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import dayjs from 'dayjs'
import FeedbackError from '../../atoms/feedbacks/feedback-error.vue'
import Loading from '../../atoms/loadings/Loading.vue'
import Pagination from '../../organism/paginations/Pagination.vue'
import SpecialBoxes from '../../organism/notifications/specials/SpecialBoxes.vue'
import url from 'url'
import qs from 'qs'

const PAGE_LIMIT = 20

export default {
  components: { FeedbackError, Loading, SpecialBoxes, Pagination },
  props: {
    isActive: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data() {
    return {
      specials: [],
      isLoading: false,
      showableErrorFeedback: false,
      errorMessage: '',
      currentPage: 1,
      totalPages: 1
    }
  },
  computed: {
    historyPath() {
      const pathname = url.parse(location.href).pathname
      const pageNumber = this.currentPage <= 1 ? 1 : this.currentPage
      return `${pathname}?page=${pageNumber}#special`
    }
  },
  mounted() {
    this.initializeParams()
    this.getSpecials(this.currentPage)
  },
  methods: {
    initializeParams() {
      const urlQueries = url.parse(location.href).query
      if (!this.isActive || !urlQueries) {
        this.currentPage = 1
        return
      }
      const parsed = qs.parse(urlQueries)
      this.currentPage = parsed.page ? Number(parsed.page) : 1
    },
    updateUrlFromParams() {
      history.pushState('', '', this.historyPath)
    },
    async getSpecials(page) {
      this.isLoading = true
      try {
        const res = await axios.get(
          `/api/v1/pickup/announcements/specials?page=${
            page ? page : 1
          }&limit=${PAGE_LIMIT}`
        )
        const { current_page, total_pages } = res.data.meta
        this.currentPage = current_page
        this.totalPages = total_pages
        this.specials = res.data.data
          .map(special => special.attributes)
          .map(special => ({
            id: special.id,
            title: special.title,
            startedAt: dayjs(special.started_at).format('YYYY年M月D日'),
            imageUrl: special.list_image_url
          }))

        // 1ページ目以外でデータが存在しないページの場合、1ページ目を表示させる
        if (page !== 1 && this.specials.length === 0) {
          await this.getSpecials(1)
          history.replaceState('', '', this.historyPath)
        }
      } catch (error) {
        this.errorMessage =
          error.response && error.response.data && error.response.data.message
            ? error.response.data.message
            : '情報の取得に失敗しました。しばらく経ってから再度アクセスしてください'
        this.showableErrorFeedback = true
      }
      this.isLoading = false
    },
    enterErrorFeedback() {
      setTimeout(() => {
        this.showableErrorFeedback = false
      }, 3000)
    },
    async onClickPageLink(page) {
      this.scrollToTop()
      await this.getSpecials(page)
      this.updateUrlFromParams()
    },
    scrollToTop() {
      window.scrollTo({ top, behavior: 'smooth' })
    }
  }
}
</script>
<style lang="scss" scoped>
.specials {
  overflow: hidden;

  &__loading {
    padding: 24px;
  }

  &__body {
    background-color: $white;
    padding-top: 16px;
  }
}
</style>
